/**
 * Remove the page-scoped Tractor State session, if one is stored.
 *
 * On the Auth0 build, `/tractor-state` runs its own Cognito login
 * (`fleetStateAuth.tsx`) and keeps that user in sessionStorage under
 * oidc-client-ts's `oidc.*` keys. Logging out of the app never touched it, so
 * the next person to sign in on the same tab inherited a fleet_state token
 * minted for the previous one. Both providers' sign-outs clear it.
 *
 * Only sessionStorage: the app-wide Cognito session lives in localStorage and is
 * removed by its own `signoutRedirect`.
 */
export function clearPageScopedFleetStateSession(): void {
  try {
    const doomed: string[] = [];
    for (let i = 0; i < window.sessionStorage.length; i += 1) {
      const key = window.sessionStorage.key(i);
      if (key && key.startsWith("oidc.")) doomed.push(key);
    }
    doomed.forEach((key) => window.sessionStorage.removeItem(key));
  } catch {
    // Storage unavailable — nothing was stored to clear.
  }
}
